//
//
//
//
//
//
//
//
//
//
//

import { areaData } from '@/util/areaData'
export default {
  name: 'areaCascader',
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    changeOnSelect: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: '1' // 查询类型 1全部地区 2省市 3省
    }
    /* ,
    defaultValue: {
      type: Array,
      default: () => [ ]
    } */
  },
  data () {
    return {
      // toolRex: toolRex,
      current: this.value,
      options: this.initOptions(),
      defaultValue: []
    }
  },
  methods: {
    initOptions () {
      const nowOpt = JSON.parse(JSON.stringify(areaData))
      if (this.type == 2) {
        nowOpt.forEach(area => {
          area.items.forEach(element => {
            element.items = null
          })
        })
      }
      if (this.type == 3) {
        nowOpt.forEach(element => {
          element.items = null
        })
      }
      return nowOpt
    },
    onChange (value, selectedOptions) {
      // alert('onChange' + 'value:' + value + 'selectedOptions' + selectedOptions)
      // console.log('---内部onChange---信息', JSON.stringify(selectedOptions))
      if (value != null && value != '') {
        const area = {}
        // 省
        area.province = selectedOptions[0].areaName
        area.provinceCode = selectedOptions[0].id
        // 市
        if (selectedOptions[1] != null) {
          area.city = selectedOptions[1].areaName
          area.cityCode = selectedOptions[1].id
        }
        // 区
        if (selectedOptions[2] != null) {
          area.district = selectedOptions[2].areaName
          area.districtCode = selectedOptions[2].id
        }
        // console.log('---内部onChange---selectedOptions', JSON.stringify(area))
        this.$emit('changeData', area)
      } else {
        this.$emit('changeData', null)
      }
    },
    setValue (value) {
      if (value != null && value.districtCode != null && value.districtCode != '') {
        this.defaultValue = [ value.provinceCode + '', value.cityCode + '', value.districtCode + '' ]
      } else if (this.changeOnSelect && value != null && value.provinceCode != null && value.provinceCode != '') {
        this.defaultValue[0] = value.provinceCode + ''
        if (value.cityCode != null && value.cityCode != '') {
          this.defaultValue[1] = value.cityCode + ''
          if (value.districtCode != null && value.districtCode != '') {
            this.defaultValue[2] = value.districtCode + ''
          }
        }
      } else {
        this.defaultValue = [ ]
      }
    },
    setFormValue (parentForm, addressElement, value) {
      this.setValue(value)
      parentForm.getFieldDecorator(addressElement, { initialValue: this.getValue(value) })
    },
    getValue (value) {
      var area = null
      if (!this.changeOnSelect && value != null && value.districtCode != null && value.districtCode != '') {
        area = {}
        area.province = value.province
        area.provinceCode = value.provinceCode
        // 市
        area.city = value.city
        area.cityCode = value.cityCode
        // 区
        area.district = value.district
        area.districtCode = value.districtCode
      } else if (this.changeOnSelect && value != null && value.provinceCode != null && value.provinceCode != '') {
        area = {}
        area.province = value.province
        area.provinceCode = value.provinceCode
        // 市
        area.city = value.city
        area.cityCode = value.cityCode
        // 区
        area.district = value.district
        area.districtCode = value.districtCode
      }
      return area
    },
    // 备用过滤目前有bug
    filter (inputValue, path) {
      return path.some(
        option => option.areaName.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/common/areaCascader/areaCascader.vue